<template>
    <div>
        
        <div class="form">
            <div class="titleStep">
                <h1>¿Cuándo es el cumpleaños de {{formData.petname}}?</h1>
                <p v-if="formData.product_type === 'fresh'">Necesitamos esta información para calcular sus porciones diarias correctamente.</p>
                <p v-else>O su día de adopción. ¡Queremos celebrar su cumpleaños con una sorpresa!</p>
            </div>
            <div class="wrap">
                <!-- Selector de método: Solo para Fresh -->
                <div v-if="formData.product_type === 'fresh'" class="columns is-multiline" style="margin-bottom: 1.5rem;">
                    <div class="column is-12">
                        <div class="age-method-selector">
                            <b-radio v-model="ageInputMethod"
                                name="age-method"
                                native-value="date"
                                @input="clearAgeData">
                                Sé la fecha exacta
                            </b-radio>
                            <b-radio v-model="ageInputMethod"
                                name="age-method"
                                native-value="approximate"
                                @input="clearAgeData">
                                Edad aproximada
                            </b-radio>
                        </div>
                    </div>
                </div>

                <div class="columns is-multiline">
                    <!-- Toys: Solo fecha (siempre) -->
                    <div v-if="formData.product_type !== 'fresh'" class="column is-12">
                        <b-field label="Fecha de cumpleaños">
                            <b-datepicker
                                v-model="form.birth"
                                placeholder="Click para seleccionar."
                                icon="calendar-today"
                                :max-date="new Date()"
                            >
                            </b-datepicker>
                        </b-field>
                    </div>

                    <!-- Fresh: Fecha exacta o aproximada -->
                    <div v-if="formData.product_type === 'fresh' && ageInputMethod === 'date'" class="column is-12">
                        <b-field label="Fecha de cumpleaños">
                            <b-datepicker
                                v-model="form.birth"
                                placeholder="Click para seleccionar."
                                icon="calendar-today"
                                :max-date="new Date()"
                            >
                            </b-datepicker>
                        </b-field>
                    </div>

                    <div v-if="formData.product_type === 'fresh' && ageInputMethod === 'approximate'" class="column is-12">
                        <b-field grouped>
                            <b-field label="Años" expanded>
                                <b-select v-model="approximateYears" placeholder="Años" @input="calculateApproximateAge">
                                    <option :value="0">0</option>
                                    <option v-for="y in 20" :key="y" :value="y">{{y}}</option>
                                </b-select>
                            </b-field>
                            <b-field label="Meses" expanded>
                                <b-select v-model="approximateMonths" placeholder="Meses" @input="calculateApproximateAge">
                                    <option :value="0">0</option>
                                    <option v-for="m in 11" :key="m" :value="m">{{m}}</option>
                                </b-select>
                            </b-field>
                        </b-field>
                        <p v-if="form.ageInMonths" class="help">Edad total: {{form.ageInMonths}} meses ({{Math.floor(form.ageInMonths/12)}} años y {{form.ageInMonths%12}} meses)</p>
                    </div>

                    <!-- Validación para Fresh -->
                    <div v-if="formData.product_type === 'fresh' && showValidationError" class="column is-12 v-column">
                        <p class="help is-danger">Por favor indica la edad de {{formData.petname}} para continuar</p>
                    </div>
                </div>
            </div>
            <b-button id="step-four-continue" type="is-primary nextButton" @click="nextStep">Continuar</b-button>
            <b-button v-if="formData.product_type !== 'fresh'" id="step-four-skip" type="is-primary nextButton" @click="nextStep" outlined>Saltar</b-button>
            <a class="backStep" @click="backStep">Volver</a>
        </div>
    </div>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required} from 'vuelidate/lib/validators'
    import StepMixin from '../../mixins/StepMixin'

    export default {
        props: ['clickedNext', 'currentStep'],
        mixins: [validationMixin, StepMixin],
        data() {
            return {
                form: {
                    birth: null,
                    ageInMonths: null,
                },
                ageInputMethod: 'date', // 'date' o 'approximate'
                approximateYears: 0,
                approximateMonths: 0,
                showValidationError: false,
            }
        },
        computed: {
            formData(){
                return this.$parent.$parent.$parent.formData 
            }
        },
        validations: {
            form: {
                birth: {  },
            }
        },
        methods: {
            clearAgeData() {
                // Limpiar datos previos al cambiar método
                this.form.birth = null;
                this.form.ageInMonths = null;
                this.approximateYears = 0;
                this.approximateMonths = 0;
                this.showValidationError = false;
            },
            calculateApproximateAge() {
                // Calcular edad total en meses
                const totalMonths = (this.approximateYears * 12) + this.approximateMonths;
                this.form.ageInMonths = totalMonths;
                
                // Calcular fecha de nacimiento aproximada
                const today = new Date();
                const birthDate = new Date(today);
                birthDate.setMonth(today.getMonth() - totalMonths);
                this.form.birth = birthDate;
                
                console.log('🐕 [StepFour] Approximate age calculated:', totalMonths, 'months');
                console.log('🐕 [StepFour] Approximate birth date:', birthDate);
            },
            nextStep(){
                // Validación para Fresh: debe tener edad
                if (this.formData.product_type === 'fresh') {
                    if (!this.form.ageInMonths || this.form.ageInMonths === 0) {
                        this.showValidationError = true;
                        return;
                    }
                }
                
                // Forzar copia de datos antes de continuar
                this.parentComputed.formData = {
                    ...this.parentComputed.formData,
                    ...this.form
                };
                
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    this.parentComputed.nextStep();
                }
            }
        },
        watch: {
            'form.birth'(newBirth) {
                if (newBirth && this.ageInputMethod === 'date') {
                    // Calcular edad en meses desde fecha exacta
                    const today = new Date();
                    const birthDate = new Date(newBirth);
                    const months = (today.getFullYear() - birthDate.getFullYear()) * 12 + 
                                   (today.getMonth() - birthDate.getMonth());
                    this.form.ageInMonths = months > 0 ? months : 0;
                    
                    console.log('🐕 [StepFour] Birth date selected:', newBirth);
                    console.log('🐕 [StepFour] Age in months calculated:', this.form.ageInMonths);
                    console.log('🐕 [StepFour] Current form data:', JSON.stringify(this.form, null, 2));
                }
            }
        }
    }
</script>

<style scoped>
.age-method-selector {
    padding: 1rem;
    background: #f5f5f5;
    border-radius: 8px;
    margin-bottom: 1rem;
}

/* Remover margin-left entre radios */
.age-method-selector .b-radio.radio + .radio {
    margin-left: 0 !important;
    margin-top: 0.5rem;
}

/* Height auto para botones */
.age-method-selector .b-radio.radio {
    height: auto !important;
}

.help {
    margin-top: 0.5rem;
    font-size: 0.9rem;
    color: #666;
}
</style>